import axios from "axios";
import { ADD_CUSTOMER_EDIT_CUSTOMER, GET_ALL_CUSTOMER, CHANGE_CUSTOMER_STATUS, SINGLE_CUSTOMER_DETAILS, GET_ALL_ACTIVE_CUSTOMER } from "../config/urlConfig";
import { convertToFormData } from "../utils/commenController";

// <-------------------------CUSTOMER------------------------------------>
// Function for handling add or edit  customer api
export async function handleAddEditCustomerApi(customerData, token) {
  try {
    
    let formData = await convertToFormData(customerData);
    let response = await axios.post(ADD_CUSTOMER_EDIT_CUSTOMER, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    console.log("response", response);

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for fetch all customer
export async function getAllCustomersDetailsApi(token, page, itemsPerPage) {
  try {
    const params =  new URLSearchParams();
    params.append('page',page)
    params.append('limit', itemsPerPage)

    let response = await axios.get(`${GET_ALL_CUSTOMER}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for handling change user status  api
export async function handleChangeCustomerStatusApi(customerId, token) {
  try {
    
    let response = await axios.patch(`${CHANGE_CUSTOMER_STATUS}/${customerId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

//Function for fetch single customer details 
export async function fetchSingleCustomerDetailsApi(token, customerId) {
  try{

    let response = await axios.get(`${SINGLE_CUSTOMER_DETAILS}/${customerId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  }catch(error){
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
} 


// Function for fetch all active  customer
export async function getAllActiveCustomersApi(token) {
  try {
  
    let response = await axios.get(GET_ALL_ACTIVE_CUSTOMER, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}


